module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-vodafonecvm-intro-card1.1@2x.76809fbe.jpg";